const BBPS_CONSTANTS = {
    GETTING_BBPS_CATEGORIES: 'GETTING_BBPS_CATEGORIES',
    GET_BBPS_CATEGORIES_SUCCESS: 'GET_BBPS_CATEGORIES_SUCCESS',
    GET_BBPS_CATEGORIES_FAILURE: 'GET_BBPS_CATEGORIES_FAILURE',

    UPDATING_BBPS_CATEGORY: 'UPDATING_BBPS_CATEGORY',
    UPDATE_BBPS_CATEGORY_SUCCESS: 'UPDATE_BBPS_CATEGORY_SUCCESS',
    UPDATE_BBPS_CATEGORY_FAILURE: 'UPDATE_BBPS_CATEGORY_FAILURE',

    DELETING_BBPS_CATEGORY: 'DELETING_BBPS_CATEGORY',
    DELETE_BBPS_CATEGORY_SUCCESS: 'DELETE_BBPS_CATEGORY_SUCCESS',
    DELETE_BBPS_CATEGORY_FAILURE: 'DELETE_BBPS_CATEGORY_FAILURE',

    GETTING_BBPS_COMPLAINTS: 'GETTING_BBPS_COMPLAINTS',
    GET_BBPS_COMPLAINTS_SUCCESS: 'GET_BBPS_COMPLAINTS_SUCCESS',
    GET_BBPS_COMPLAINTS_FAILURE: 'GET_BBPS_COMPLAINTS_FAILURE',

    CREATING_BBPS_COMPLAINT: 'CREATING_BBPS_COMPLAINT',
    CREATE_BBPS_COMPLAINT_SUCCESS: 'CREATE_BBPS_COMPLAINT_SUCCESS',
    CREATE_BBPS_COMPLAINT_FAILURE: 'CREATE_BBPS_COMPLAINT_FAILURE',

    UPDATING_BBPS_COMPLAINT: 'UPDATING_BBPS_COMPLAINT',
    UPDATE_BBPS_COMPLAINT_SUCCESS: 'UPDATE_BBPS_COMPLAINT_SUCCESS',
    UPDATE_BBPS_COMPLAINT_FAILURE: 'UPDATE_BBPS_COMPLAINT_FAILURE',

    CLEAR_BBPS_CATEGORIES: 'CLEAR_BBPS_CATEGORIES',
}

export default BBPS_CONSTANTS;